import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=2a82a12a&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"
import style0 from "./Index.vue?vue&type=style&index=0&id=2a82a12a&prod&lang=css"
import style1 from "./Index.vue?vue&type=style&index=1&id=2a82a12a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a82a12a",
  null
  
)

export default component.exports